import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../components/Modal/Modal';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';
import { transformValueFloattoFormated } from '../../../../helpers/formats';

//Context
import { useAuth } from '../../../../context/auth';

//Contanst
import { actionsTable } from '../../../../constants/MaterialTable';

//API
import indiceIPCA_api from '../../../../api/indiceIPCA_api';
import moment from 'moment';

function initialStateIndiceIPCA() {
    return {
        inicioVigencia: "",
        fimVigencia: "",
        indice: "0,00",
        indicePrevisto: "0,00",
    }
}

export default function IndiceIPCA() {

    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    //Estado de controle da lista de documentos
    const [indiceIPCAs, setIndiceIPCAs] = useState([]);

    //Estado para cadastro e edição
    const [cadastro, setCadastro] = useState(initialStateIndiceIPCA());

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Estado para controlar visibilidade de abri ou fecha modal
    const [isOpenModal, setIsOpenModal] = useState(false);

    const toggleModal = () => {
        setIsOpenModal(!isOpenModal);
        setCadastro(initialStateIndiceIPCA());
    };

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Início Vigência", objectValue: "inicioVigenciaFormatado", align: "left" },
        { value: "Fim Vigência", objectValue: "fimVigenciaFormatado", align: "left" },
        { value: "Índice", objectValue: "indiceFormatado", align: "left" },
        { value: "Índice Previsto", objectValue: "indicePrevistoFormatado", align: "left" },
    ];

    //Função do botão visualizar da lista
    function editar(rowData) {
        setCadastro(rowData);
        setIsOpenModal(true);
    };

    //Ações que a tabela terá
    const actions = [actionsTable.editar(editar)];

    // Lista
    const campos = [
        objCampo({ name: "inicioVigencia", required: true }),
        objCampo({ name: "fimVigencia", required: true }),
        objCampo({ name: "indice", required: true })
    ];

    //Função para alterar state da lista de opções
    const onChange = (e) => {
        const { name, value } = e.target;
        const _cadastro = {
            ...cadastro,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_cadastro, _campos);

        const _errors = { ...errors };
        delete _errors[name];

        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setCadastro(_cadastro);
    }

    function onSubmit() {
        const _errors = validarCampos(cadastro, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        if (cadastro.inicioVigencia > cadastro.fimVigencia) {
            showMessage("Aviso", "A data de início da vigência não pode ser maior que fim de vingência.", "warning", null);
            return
        }

        const _indiceIPCA = { ...cadastro };
        _indiceIPCA.indice = _indiceIPCA.indice.replace(",", ".");
        _indiceIPCA.indicePrevisto = _indiceIPCA.indicePrevisto.replace(",", ".");

        if (_indiceIPCA?.id) {
            setLoading(true);
            indiceIPCA_api.put(_indiceIPCA).then(response => {
                showMessage("Sucesso", "Sucesso na Operação.", "success", () => {
                    toggleModal();
                    loadIndiceIPCAs();
                });
            })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            indiceIPCA_api.post(_indiceIPCA).then(response => {
                showMessage("Sucesso", "Sucesso na Operação.", "success", () => {
                    toggleModal();
                    loadIndiceIPCAs();
                });
            })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Função que carrega a lista de documentos
    function loadIndiceIPCAs() {
        setLoading(true);
        indiceIPCA_api.getList().then(response => {
            response.data = response.data.map(value => {
                value.inicioVigenciaFormatado = moment(value.inicioVigencia).format("DD/MM/YYYY");
                value.fimVigenciaFormatado = moment(value.fimVigencia).format("DD/MM/YYYY");

                value.inicioVigencia = moment(value.inicioVigencia).format("YYYY-MM-DD");
                value.fimVigencia = moment(value.fimVigencia).format("YYYY-MM-DD");

                value.indiceFormatado = transformValueFloattoFormated(value.indice) + " %";
                value.indice = transformValueFloattoFormated(value.indice);

                value.indicePrevistoFormatado = value?.indicePrevisto ? transformValueFloattoFormated(value.indicePrevisto) + " %" : "0,00 %";
                value.indicePrevisto = value.indicePrevisto ? transformValueFloattoFormated(value.indicePrevisto) : "0,00 %";

                return value;
            })
            setIndiceIPCAs(response.data);
        })
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadIndiceIPCAs();
    }, []);


    return (
        <>
            {isOpenModal &&
                <ModalCustomized
                    toggle={toggleModal}
                    isOpen={isOpenModal}
                    btnClose={toggleModal}
                    title={cadastro?.id ? "Editando Índice IPCA" : "Cadastro Índice IPCA"}
                >
                    <Row>
                        <Col md={4} lg={3}>
                            <TextField
                                invalid={errors.inicioVigencia}
                                label={"* Início Vigência"}
                                type="date"
                                name={"inicioVigencia"}
                                value={cadastro.inicioVigencia}
                                onChange={onChange}
                            />
                        </Col>

                        <Col md={4} lg={3}>
                            <TextField
                                invalid={errors.fimVigencia}
                                label={"* Fim Vigência"}
                                type="date"
                                name={"fimVigencia"}
                                value={cadastro.fimVigencia}
                                onChange={onChange}
                            />
                        </Col>

                        <Col md={4} lg={3}>
                            <TextField
                                invalid={errors.indice}
                                label={"Índice"}
                                type="text"
                                name={"indice"}
                                value={cadastro.indice}
                                mask={mascaras.floatMask}
                                onChange={onChange}
                            />
                        </Col>

                        <Col md={4} lg={3}>
                            <TextField
                                invalid={errors.indicePrevisto}
                                label={"Índice Previsto"}
                                type="text"
                                name={"indicePrevisto"}
                                value={cadastro.indicePrevisto}
                                mask={mascaras.floatMask}
                                onChange={onChange}
                            />
                        </Col>

                        <Col
                            md={12}
                            lg={12}
                            className={`d-flex align-items-center justify-content-center`}
                        >
                            <Button
                                className='px-4 mb-3 text-white'
                                color={cadastro?.id ? 'warning' : 'success'}
                                onClick={onSubmit}>
                                <FontAwesomeIcon icon={cadastro?.id ? faEdit : faSave} /> {cadastro?.id ? "Editar" : "Salvar"}
                            </Button>
                        </Col>
                    </Row>
                </ModalCustomized>
            }

            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Índice IPCA</h4>
                <Button
                    color='success'
                    onClick={() => {
                        setIsOpenModal(true)
                    }}
                >
                    + Cadastrar
                </Button>
            </div >
            <TabelaListagem
                actions={actions}
                title={"Lista de Índice IPCA"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={indiceIPCAs}
            />
        </>
    )
}
